import { z } from 'zod';
import { requiredIntFromNumberInput, requiredReferenceIdSchema } from '@/shared/utils/formZod.schema.utils';

export const setorFormSchema = z
  .object({
    sigla: z.string().trim().min(1, 'Informe a sigla'),
    nome: z.string().trim().min(1, 'Informe o nome do setor'),
    capacidade: requiredIntFromNumberInput({
      requiredMessage: 'Informe a capacidade',
      min: 1,
      max: 999,
      minMessage: 'Capacidade mínima: 1',
      maxMessage: 'Capacidade máxima: 999',
    }),
    predio: requiredReferenceIdSchema,
    responsavel: z
      .object({
        id: z.string().min(1),
      })
      .optional()
      .nullable(),
  })
  .passthrough();

export type SetorFormValues = z.infer<typeof setorFormSchema>;
